module.exports = __webpack_public_path__ + "static/media/fantastico.961bce41.jpg";